// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"11bd0517","405":"422513a8","487":"422513a8","529":"422513a8","606":"612e704e","956":"cbb334d8"}[chunkId] + ".chunk.css";
};